export const SET_TOKEN = 'SET_TOKEN';
export const GET_ME = 'GET_ME';
export const LOG_OUT = 'LOG_OUT';
export const SET_USER = 'SET_USER';
export const SET_ERROR = 'SET_ERROR';